{
  "#UPDATED_ARTICLE_LABEL_PRINT": {
    "TITLE": "Etikettendruck geänderte Artikel",
    "FILTER": {
      "TITLE": "Abfrage",
      "SECTION_FILTER": "Filter",
      "SECTION_OPTIONEN": "Optionen",
      "STICHTAG": "Stichtag",
      "FILIALE": "Filiale",
      "PREISEBENE": "Preisebene",
      "PREISEBENE_DEFAULT_CAPTION": "Aus Anmeldung",
      "AKTIONEN": "Aktionen",
      "AKTIONEN_ALLE_ARTIKEL": "Alle Artikel",
      "AKTIONEN_OHNE_AKTIONSARTIKEL": "Ohne Aktionsartikel",
      "LIEFERANT": "Lieferant",
      "WARENGRUPPE": "Warengruppe",
      "UNTERGRUPPE": "Untergruppe",
      "ARTIKEL_MIT_LAGERSTAND": "Artikel mit Lagerstand",
      "ARTIKEL_MIT_LAGERPLATZ": "Artikel mit Lagerplatz",
      "RESET": "Filter zurücksetzen",
      "APPLY": "Bestätigen"
    },
    "CHANGE_BADGE": {
      "BEZEICHNUNG": "Bezeichnung",
      "EINHEIT": "Einheit",
      "VKP": "VKP",
      "SUPPLIER": "Lieferant",
      "EAN": "EAN",
      "ARTICLE_NUMBER": "Artikelnummer",
      "LISTED_STATUS": "Gelistet-Status",
      "PROMOTION": "Aktion"
    },
    "TABS": {
      "ALLE": "Alle",
      "REGALETIKETT": "Regaletikett",
      "FAHNCHEN": "Fähnchen",
      "ARTIKELETIKETT": "Artikeletikett"
    },
    "LIST": {
      "ARTIKEL": "Artikel",
      "ARTIKEL_NR": "Artikel Nr.",
      "AENDERUNGEN": "Änderungen",
      "VKP_ALT": "VKP alt",
      "VKP_NEU": "VKP neu",
      "VKP_CHANGE": "VKP Veränderung",
      "BEZEICHNUNG_ALT": "Bezeichnung alt",
      "BEZEICHNUNG_NEU": "Bezeichnung neu",
      "EINHEIT_ALT": "Einheit alt",
      "EINHEIT_NEU": "Einheit neu",
      "AENDERUNG": "Änderung",
      "SELECT_ALL": "Alle auswählen",
      "SELECTED_OF_TOTAL": "{{selected}} von {{total}} ausgewählt"
    },
    "EMPTY": {
      "TITLE": "Keine geänderten Artikel",
      "BODY": "Für die gewählte Filter liegen aktuell keine Etikett-Änderungen vor."
    },
    "FORBIDDEN": {
      "TITLE": "Keine Berechtigung",
      "BODY": "Ihr Benutzer darf den Etikettendruck nicht aufrufen (HTTP 403). Bitte an die Systemadministration wenden."
    },
    "SERVICE_ERROR": {
      "TITLE": "Abfrage fehlgeschlagen",
      "BODY": "Der Etiketten-Service ist derzeit nicht erreichbar (HTTP 503). Bitte erneut versuchen.",
      "RETRY": "Erneut versuchen"
    },
    "PRINT": {
      "BUTTON": "Etiketten drucken",
      "SUCCESS": "Etiketten wurden gedruckt.",
      "PARTIAL_FAILURE": "Einige Etiketten konnten nicht gedruckt werden.",
      "ALL_FAILED": "Die Etiketten konnten nicht gedruckt werden."
    },
    "BULK_TYPE": {
      "SET_TYPE": "Labeltyp ändern",
      "TOAST_SINGLE": "Typ auf „{{type}}“ geändert",
      "TOAST_MULTI": "{{count}} Artikel auf „{{type}}“ geändert"
    }
  }
}
